module.exports = __webpack_public_path__ + "static/media/UE-PL-Top-white.805d07f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/UE-PL-Top-white.svg
// module id = 242
// module chunks = 0